import { Component } from '@angular/core';

@Component({
  selector: 'skeleton-estadisticas-grafica',
  templateUrl: 'skeleton-estadisticas-grafica.html'
})
export class SkeletonEstadisticasGraficaComponent {

  constructor() {
  }

}



// WEBPACK FOOTER //
// ./src/components/skeleton-estadisticas-grafica/skeleton-estadisticas-grafica.ts